/**
 * Filtra entradas del sidebar según `route.sidebarAmbiente` y el ambiente SII
 * resuelto desde perfiles de emisión (certificación / producción).
 *
 * - Sin `sidebarAmbiente` en la ruta: visible en ambos ambientes.
 * - Con `sidebarAmbiente: "certificacion" | "produccion"`: solo si el perfil DTE
 *   único coincide (misma detección que el badge del navbar).
 * - Perfil mixto, sin datos, error o carga: no se oculta nada (evita bloquear navegación).
 */
export function filterRoutesForSidebar(routes, emissionState) {
  if (!Array.isArray(routes)) return routes;
  if (emissionState == null) return routes;
  if (emissionState.kind !== "ready") return routes;
  const { mixed, ambiente } = emissionState;
  if (mixed || !ambiente) return routes;

  return routes.filter((r) => {
    const tag = r.sidebarAmbiente;
    if (!tag) return true;
    return tag === ambiente;
  });
}
